(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('SALA_MUSEO_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<sala-museo-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></sala-museo-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (SalaMuseo) {
                        return new SalaMuseo();
                    }
                }
            }
        });
})();
